export const AVAILABILITY_REASONS = ['dsb_check', 'processing', 'processing_error'] as const;

export type AvailabilityBlockReason = (typeof AVAILABILITY_REASONS)[number];
